import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { authRequest } from "../actions";
import { connect } from "react-redux";

const PublicRoute = (props) => {
  const { authRequest } = props;

  useEffect(() => {
    authRequest();
  }, [authRequest]);

  return (
    <Box minWidth="354px">
      <NavBar />
      <Outlet />
      {props.footer ? <Footer /> : null}
    </Box>
  );
};

const mapStateToprops = (state) => {
  return state;
};

export default connect(mapStateToprops, { authRequest })(PublicRoute);
